module.exports = __webpack_public_path__ + "img/ORB.95677417.png";